/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Respresents whether or not a student has been successfully billed for a meeting
 */
export enum MeetingStudentBillingStatus {
  STUDENT_BILLED = "STUDENT_BILLED",
  STUDENT_BILLED_FEE = "STUDENT_BILLED_FEE",
  NO_BILLING_APPLIES = "NO_BILLING_APPLIES",
  BILLING_QUEUED = "BILLING_QUEUED",
  STUDENT_BILLING_FAILED = "STUDENT_BILLING_FAILED",
  STUDENT_NOT_BILLED = "STUDENT_NOT_BILLED",
}
